import type { LucideIcon } from 'lucide-react'
import type { RoadmapStatus } from '~/pages/backoffice/admin/roadmap/roadmap-data'
import { CheckCircle2, Rocket, Telescope } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Badge } from '~/components/ui/badge'
import { Card, CardContent, CardHeader, CardTitle } from '~/components/ui/card'
import { ROADMAP_ITEMS } from '~/pages/backoffice/admin/roadmap/roadmap-data'

const SECTIONS: {
  status: RoadmapStatus
  icon: LucideIcon
  iconClass: string
  dotClass: string
}[] = [
  { status: 'done', icon: CheckCircle2, iconClass: 'text-green-500', dotClass: 'bg-green-500' },
  { status: 'planned', icon: Rocket, iconClass: 'text-primary', dotClass: 'bg-primary' },
  { status: 'exploring', icon: Telescope, iconClass: 'text-muted-foreground', dotClass: 'bg-muted-foreground' },
]

function RoadmapPage() {
  const { t } = useTranslation()

  return (
    <div className="mx-auto flex w-full max-w-6xl flex-col gap-6 p-4">
      <div className="flex flex-col gap-1">
        <div className="flex items-center gap-3">
          <h1 className="text-2xl font-semibold">{t('roadmap.title')}</h1>
          <Badge variant="secondary">{`v${__APP_VERSION__}`}</Badge>
        </div>
        <p className="text-sm text-muted-foreground">{t('roadmap.subtitle')}</p>
      </div>

      <div className="grid gap-6 xl:grid-cols-3">
        {SECTIONS.map(({ status, icon: Icon, iconClass, dotClass }) => {
          const items = ROADMAP_ITEMS.filter(item => item.status === status)
          if (items.length === 0) return null

          return (
            <Card key={status}>
              <CardHeader>
                <CardTitle className="flex items-center gap-2">
                  <Icon className={`size-5 ${iconClass}`} />
                  {t(`roadmap.status.${status}`)}
                  <Badge variant="outline">{items.length}</Badge>
                </CardTitle>
              </CardHeader>
              <CardContent>
                <ol className="ml-2.5 border-l border-border">
                  {items.map(item => (
                    <li key={item.key} className="relative pb-6 pl-6 last:pb-0">
                      <span className={`absolute -left-[5px] top-1.5 size-2.5 rounded-full ${dotClass}`} />
                      <p className="font-medium leading-tight">{t(`roadmap.items.${item.key}.title`)}</p>
                      <p className="mt-1 text-sm text-muted-foreground">{t(`roadmap.items.${item.key}.description`)}</p>
                    </li>
                  ))}
                </ol>
              </CardContent>
            </Card>
          )
        })}
      </div>
    </div>
  )
}

export default RoadmapPage
